import React from "react";
import PropTypes from "prop-types";
import {
  Paper,
  Typography,
  Grid,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  List,
  ListItem,
  Divider,
  Button
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16
  }),
  body: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 16
  }),
  button: {
    fontSize: "16px"
  },
  table: {
    minWidth: 700
  },
  divider: {
    paddingTop: 16
  }
});

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      build: this.getBuild(),
      theme: this.getTheme(),
      builds: ["stable", "canary"],
      themes: ["Altola", "Sitecore"],
      changed: false
    };
  }

  getTheme() {
    let theme;
    if (window && window.localStorage) {
      theme = window.localStorage.getItem("altola-optimus-theme");
    }
    return theme ? theme : "Altola";
  }

  getBuild() {
    let build;
    if (window && window.localStorage) {
      build = window.localStorage.getItem("altola-optimus-build");
    }
    return build ? build : "stable";
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ changed: true });
  };

  applyChanges = event => {
    if (!window || !window.localStorage) {
      throw "local storage is inaccessible";
    }

    window.localStorage.setItem(
      "altola-optimus-theme",
      this.state.theme
    );

    window.localStorage.setItem(
      "altola-optimus-build",
      this.state.build
    );

    this.setState({ changed: false });
    window.location.reload();
  }

  render() {
    const { builds, themes, changed } = this.state;
    const { classes } = this.props;

    return (
      <div>
        <Paper className={classes.root} elevation={4}>
          <Typography variant="headline" component="h1">
            Change app settings
          </Typography>
          <Typography component="p">
            The application settings are stored per user.
          </Typography>
        </Paper>

        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Paper className={classes.body} elevation={4}>
              <form className={classes.root} autoComplete="off">
                <List>
                  <ListItem>
                    <FormControl className={classes.formControl}>
                      <InputLabel
                        className={classes.label}
                        htmlFor="build-selector"
                      >
                        Build
                      </InputLabel>
                      <Select
                        className={classes.select}
                        value={this.state.build}
                        onChange={this.handleChange}
                        inputProps={{
                          name: "build",
                          id: "build-selector"
                        }}
                      >
                        {builds.map(build => (
                          <MenuItem key={build} value={build}>
                            {build}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </ListItem>
                  <li>
                    <Divider />
                  </li>
                  <ListItem>
                    <FormControl className={classes.formControl}>
                      <InputLabel
                        className={classes.label}
                        htmlFor="theme-selector"
                      >
                        Theme
                      </InputLabel>
                      <Select
                        className={classes.select}
                        value={this.state.theme}
                        onChange={this.handleChange}
                        inputProps={{
                          name: "theme",
                          id: "theme-selector"
                        }}
                      >
                        {themes.map(theme => (
                          <MenuItem key={theme} value={theme}>
                            {theme}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </ListItem>
                  <ListItem>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      disabled={!changed}
                      onClick={this.applyChanges}
                    >
                      Apply changes
                    </Button>
                  </ListItem>
                </List>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }
}

Settings.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Settings);



// WEBPACK FOOTER //
// ./src/containers/Settings.js